<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rulesProcedings"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1">
            <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{$t('procedings.create_title')}}</h2>

            <div class="lg:mb-2" v-if="!isCreate && (role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div class="flex justify-between items-center">
                <div class="flex-1">
                  <AccessibleElSelect
                    v-model="form.clienteId"
                    prop="clienteId"
                    :options="clientesForAccessibleSelect"
                    isDisabled
                    id-prefix="proceding"
                  >
                    <template slot="label">
                      {{$t('app.client')}}
                    </template>
                  </AccessibleElSelect>
                </div>
                <base-button
                  v-if="!isCreate"
                  class="ml-4"
                  mode="primary"
                  :text="$t('app.detail')"
                  @click.prevent.stop="goDetailClient"
                  :loading="isGeneralLoading"
                />
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('procedings.TicketID')}}
                  <el-form-item prop="TicketID">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.TicketID"
                      maxlength='300'
                      disabled
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('procedings.NIFPagadora')}}
                  <el-form-item prop="NIFPagadora">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.NIFPagadora"
                      maxlength='30'
                      disabled
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('procedings.NumDiligencia')}}
                  <el-form-item prop="NumDiligencia">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.NumDiligencia"
                      maxlength='30'
                      disabled
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('procedings.NIFDeudor')}}
                  <el-form-item prop="NIFDeudor">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.NIFDeudor"
                      maxlength='9'
                      :disabled="!isCreate || disableNIFDeudor"
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="mb-4">
              <AccessibleElSelect
                v-model="form.Tipo"
                prop="Tipo"
                :options="TiposForAccessibleSelect"
                clearable
                id-prefix="proceding"
                :isDisabled="!isCreate"
              >
                <template slot="label">
                  <base-obligatory-icon v-if="isCreate"/>
                  {{$t('procedings.Tipo')}}
                </template>
              </AccessibleElSelect>
            </div>

            <div v-if="!isCreate" class="mb-6">
              <div class="flex flex-col lg:flex-row gap-x-2 w-full mb-2">
                <div class="w-full" v-if="form.Estado">
                  <base-ro-input :label="$t('procedings.Estado')" :data="form.Estado"/>
                </div>
                <div class="w-full" v-if="form.CSV">
                  <base-ro-input :label="$t('procedings.CSV')" :data="form.CSV"/>
                </div>
              </div>
              <div class="mb-2" v-if="form.Error">
                <base-ro-input :label="$t('procedings.Error')" :data="form.Error"/>
              </div>
            </div>

            <base-collapsible-form 
              v-if="form.Tipo === 1"
              ref="baseCollapsibleProcedingCreditos" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('procedings.creditos')}}</h2>
              </template>
              <template slot="content">

                <div class="mt-2 mb-4">
                  <label for="switch-group-alert-active" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                    {{$t('procedings.TieneCantidadesPendientesPagoORelacion')}}
                    <span class="sr-only">{{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                  </label>
                  <el-switch 
                    id="switch-group-alert-active"
                    :aria-label="$t('procedings.TieneCantidadesPendientesPagoORelacion')"
                    class="switch-text break-normal mt-2" 
                    :disabled="!isCreate" 
                    v-model="form.TieneCantidadesPendientesPagoORelacion"
                    :active-text="$t('companies.active')">
                  </el-switch>
                </div>


                <div v-if="form.TieneCantidadesPendientesPagoORelacion">
                <div class="mt-2 mb-4">
                  <label for="switch-group-alert-active" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                    {{$t('procedings.TieneRelacionComercial')}}
                    <span class="sr-only">{{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                  </label>
                  <el-switch 
                    id="switch-group-alert-active"
                    :aria-label="$t('procedings.TieneRelacionComercial')"
                    class="switch-text break-normal mt-2" 
                    :disabled="!isCreate" 
                    v-model="form.TieneRelacionComercial"
                    :active-text="$t('companies.active')">
                  </el-switch>
                </div>

                <div v-if="!form.TieneRelacionComercial">
                <h3 class="dark:text-darkblue-200 text-sm font-bold mt-4 mb-4">{{$t('procedings.ImportesPendientes')}}</h3>

                <base-accessible-table
                  ref="procedingsimportes"
                  :rows="form.ImportesPendientes"
                  :columns="ImportesPendientesMetadataColumns"
                  :rowKey="row => row.idImporte"
                  :enableScroll="true"
                  :maxBodyHeight="250"
                >
                  <template #cell-Concepto="{ row }">
                    <span :title="row.Concepto">{{ row.Concepto }}</span>
                  </template>
                  <template #cell-FechaVencimiento="{ row }">
                    <span :title="row.FechaVencimiento">{{ row.FechaVencimiento }}</span>
                  </template>
                  <template #cell-Importe="{ row }">
                    <span :title="row.Importe">{{ row.Importe }}</span>
                  </template>
                  <template #cell-actions="{ row }" v-if="isCreate">
                    <div class="flex flex-row justify-end">
                      <base-button-icon @click="deleteImportePendiente(row)" name="trash" mode="core" size="xs" ariaLabel="Eliminar importe pendiente" />
                    </div>
                  </template>
                </base-accessible-table>
                <div class="w-full float-right" v-if="isCreate">
                  <base-button-responsive
                    mode="primary"
                    :text="$t('procedings.Importe_add')"
                    @click="newImportePendienteToggleDialog()"
                    icon="plus"
                    class="m-5 float-right"
                    :loading="isGeneralLoading"
                    :disabled="isGeneralLoading"
                  />
                </div>
                <div v-else class="mb-5"/>
                </div>
              </div>

                  
              </template>
            </base-collapsible-form>

            <base-collapsible-form 
              v-if="form.Tipo === 2"
              ref="baseCollapsibleProcedingSueldos" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('procedings.sueldos')}}</h2>
              </template>
              <template slot="content">

              <div class="mt-2 mb-4">
                <label for="switch-group-alert-active" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                  {{$t('procedings.MantieneRelacionLaboral')}}
                  <span class="sr-only">{{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                </label>
                <el-switch 
                  id="switch-group-alert-active"
                  :aria-label="$t('procedings.MantieneRelacionLaboral')"
                  class="switch-text break-normal mt-2" 
                  :disabled="!isCreate" 
                  v-model="form.MantieneRelacionLaboral"
                  :active-text="$t('companies.active')">
                </el-switch>
              </div>

              <div v-if="form.MantieneRelacionLaboral">

                <div class="mt-2 mb-4">
                  <label for="switch-group-alert-active" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                    {{$t('procedings.RetribucionesSalarialesSuperioresSMI')}}
                    <span class="sr-only">{{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                  </label>
                  <el-switch 
                    id="switch-group-alert-active"
                    :aria-label="$t('procedings.RetribucionesSalarialesSuperioresSMI')"
                    class="switch-text break-normal mt-2" 
                    :disabled="!isCreate" 
                    v-model="form.RetribucionesSalarialesSuperioresSMI"
                    :active-text="$t('companies.active')">
                  </el-switch>
                </div>

                <div class="mt-2 mb-4">
                  <label for="switch-group-alert-active" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                    {{$t('procedings.RetribucionesNoSalariales')}}
                    <span class="sr-only">{{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                  </label>
                  <el-switch 
                    id="switch-group-alert-active"
                    :aria-label="$t('procedings.RetribucionesNoSalariales')"
                    class="switch-text break-normal mt-2" 
                    :disabled="!isCreate" 
                    v-model="form.RetribucionesNoSalariales"
                    :active-text="$t('companies.active')">
                  </el-switch>
                </div>

              </div>
              <div v-else>

                <div class="mt-2 mb-4">
                  <label for="switch-group-alert-active" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                    {{$t('procedings.TieneCantidadesPendientesPago')}}
                    <span class="sr-only">{{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                  </label>
                  <el-switch 
                    id="switch-group-alert-active"
                    :aria-label="$t('procedings.TieneCantidadesPendientesPago')"
                    class="switch-text break-normal mt-2" 
                    :disabled="!isCreate" 
                    v-model="form.TieneCantidadesPendientesPago"
                    :active-text="$t('companies.active')">
                  </el-switch>
                </div>

                <div v-if="form.TieneCantidadesPendientesPago">
                <div class="lg:mb-2">
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('procedings.RetribucionesPendientesNaturalezaSalarial')}}
                      <el-form-item prop="RetribucionesPendientesNaturalezaSalarial">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.RetribucionesPendientesNaturalezaSalarial"
                          maxlength='23'
                          :disabled="!isCreate"
                          @input="onRetribucionesPendientesNaturalezaSalarialInput"
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>

                <div class="lg:mb-2">
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('procedings.RetribucionesPendientesNaturalezaNoSalarial')}}
                      <el-form-item prop="RetribucionesPendientesNaturalezaNoSalarial">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.RetribucionesPendientesNaturalezaNoSalarial"
                          maxlength='23'
                          :disabled="!isCreate"
                          @input="onRetribucionesPendientesNaturalezaNoSalarialInput"
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
                </div>

              </div>
                  
              </template>
            </base-collapsible-form>

            <base-collapsible-form
              v-if="isEmbargoPrevioVisible"
              ref="baseCollapsibleProcedingEmbargoPrevio" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('procedings.embargo_previo')}}</h2>
              </template>
              <template slot="content">

                <div class="lg:mb-2">
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('procedings.NIFEmbargante')}}
                      <el-form-item prop="NIFEmbargante">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.NIFEmbargante"
                          maxlength='9'
                          :disabled="!isCreate"
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>

                <div class="lg:mb-2">
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('procedings.NombreEmbargante')}}
                      <el-form-item prop="NombreEmbargante">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.NombreEmbargante"
                          maxlength='100'
                          :disabled="!isCreate"
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>

                <div v-if="form.NIFEmbargante || form.NombreEmbargante">

                <div class="lg:mb-2">
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('procedings.ImporteEmbargoPrevio')}}
                      <el-form-item prop="ImporteEmbargoPrevio">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.ImporteEmbargoPrevio"
                          maxlength='23'
                          :disabled="!isCreate"
                          @input="onImporteEmbargoPrevioInput"
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>

                <div class="lg:mb-4 flex items-center">
                  <label class="text-sm font-semibold dark:text-darkblue-200 text-secondary-600 block">
                    <div class="flex items-center">
                      <base-obligatory-icon v-if="isCreate" class="mr-1"/>
                      {{$t('procedings.FechaEmbargoPrevio')}}
                    </div>
                    <el-form-item prop="FechaEmbargoPrevio">
                      <el-date-picker
                        :clearable="false"
                        :disabled="!isCreate"
                        class="bg-white dark:bg-darkblue-900"
                        v-model="form.FechaEmbargoPrevio"
                        :picker-options="dateRangeOptions"
                        type="date"
                        format="dd-MM-yyyy"
                        placeholder="dd-mm-aaaa"
                        ref="datePickerFechaEmbargoPrevio"
                        @blur="onBlurDatePickerMixin('.datePickerFechaEmbargoPrevio-popover')"
                        @focus="onFocusDatePickerMixin('.datePickerFechaEmbargoPrevio-popover')"
                        @keydown.native="captureKeyNotChrome"
                        popper-class="datePickerFechaEmbargoPrevio-popover"
                        >
                      </el-date-picker>
                    </el-form-item>                
                  </label>
                  <base-clear-input-button
                    v-if="form.FechaEmbargoPrevio && isCreate"
                    aria-label="Limpiar fecha"
                    @clear="form.FechaEmbargoPrevio = null"
                  />
                </div>

                <div class="lg:mb-2" v-if="form.Tipo === 1">
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('procedings.DatosAdicionalesEmbargo')}}
                      <el-form-item prop="DatosAdicionalesEmbargo">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.DatosAdicionalesEmbargo"
                          maxlength='530'
                          :disabled="!isCreate"
                          type="textarea"
                          :rows="5"
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
                </div>
                  
              </template>
            </base-collapsible-form>

            <base-collapsible-form 
              ref="baseCollapsibleProcedingInformacionAdicional" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('procedings.informacion_adicional')}}</h2>
              </template>
              <template slot="content">

                <div class="lg:mb-2">
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('procedings.TelefonoContacto')}}
                      <el-form-item prop="TelefonoContacto">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.TelefonoContacto"
                          maxlength='12'
                          :disabled="!isCreate"
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>

                <div class="lg:mb-2" v-if="form.Tipo === 2">
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('procedings.Observaciones')}}
                      <el-form-item prop="Observaciones">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.Observaciones"
                          maxlength='530'
                          :disabled="!isCreate"
                          type="textarea"
                          :rows="5"
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
                  
              </template>
            </base-collapsible-form>

            <base-collapsible-form 
              ref="baseCollapsibleProcedingCert" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('procedings.cert')}}</h2>
              </template>
              <template slot="content">
                <div class="lg:mb-2" v-if="isCreate">
                  <AccessibleElSelect
                    v-model="form.Certificado"
                    prop="Certificado"
                    :options="certificadosForAccessibleSelect"
                    :withFormItem="true"
                    :isDisabled="isLoadingInitial || !isCreate"
                    id-prefix="proceding"
                  >
                    <template slot="label"><base-obligatory-icon v-if="isCreate"/>{{$t('app.available_certificates')}}</template>
                  </AccessibleElSelect>
                </div>
                <div class="lg:mb-2" v-else>
                  <div v-if="form.CertificadoCN" class="flex space-between items-end m-2">
                    <div class="w-full">
                      <h2 class="px-2 w-full mb-2 lg:mb-0 font-bold dark:text-secondary-200">Certificado</h2>
                      <div  class="px-2 w-full mt-2">
                        <base-ro-input-minimal :label="$t('certificates.name')" :data="form.CertificadoCN"/>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </base-collapsible-form>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            v-if="isCreate"
            mode="primary"
            :text="$t('app.save')"
            icon="save"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <!-- Acciones dinamicas -->
          <base-button-responsive
            v-if="!isCreate && this.form.idEstado === 1"
            mode="primary"
            :text="$t('documentmaster.visualize')"
            icon="eye"
            @click="toggleDialogPdf()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isCreate && this.form.idEstado === 1"
            mode="primary"
            :text="$t('documentmaster.download')"
            icon="download"
            @click="downloadAdjunto()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isCreate && this.form.idEstado === 2"
            mode="primary"
            :text="$t('app.retry')"
            icon="retry"
            @click="actualizarEstadoHandler(0)"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isCreate && this.form.idEstado === 2"
            mode="primary"
            :text="$t('imports.cancel')"
            icon="trash"
            @click="actualizarEstadoHandler(3)"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>

        <BaseElDialog
          title="Añadir importe"
          :visible.sync="showModalImportePendiente"
            @open="handleOpenModalDialog([
              'container-handleOpenModal-insert-importe-body',
              'container-handleOpenModal-insert-importe',
              ])"
            @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <div 
            class="overflow-x-hidden"
            ref="container-handleOpenModal-insert-importe-body"
            >
            <el-form
              :model="formImportePendiente"
              ref="importeRules"
              :rules="importeRules"
            >
              <div class="lg:mb-2">

                <div class="flex flex-col lg:flex-row gap-x-2">
                  <div class="w-full">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('procedings.Importe')}}
                        <el-form-item prop="Importe">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="formImportePendiente.Importe"
                            maxlength='23'
                            @input="onImporteInput"
                          />
                        </el-form-item>
                      </label>
                    </div>
                  </div>

                  <div class="w-full flex items-center">
                    <label class="text-sm font-semibold dark:text-darkblue-200 text-secondary-600 block">
                      <div class="flex items-center gap-x-2">
                        <base-obligatory-icon/>
                        {{$t('procedings.FechaVencimiento')}}
                      </div>
                      <el-form-item prop="FechaVencimiento">
                        <el-date-picker
                          :clearable="false"
                          class="bg-white dark:bg-darkblue-900"
                          v-model="formImportePendiente.FechaVencimiento"
                          :picker-options="dateRangeOptions"
                          type="date"
                          format="dd-MM-yyyy"
                          placeholder="dd-mm-aaaa"
                          ref="datePickerFechaVencimiento"
                          @blur="onBlurDatePickerMixin('.datePickerFechaVencimiento-popover')"
                          @focus="onFocusDatePickerMixin('.datePickerFechaVencimiento-popover')"
                          @keydown.native="captureKeyNotChrome"
                          popper-class="datePickerFechaVencimiento-popover"
                          >
                        </el-date-picker>
                      </el-form-item>                
                    </label>
                    <base-clear-input-button
                      v-if="formImportePendiente.FechaVencimiento && isCreate"
                      aria-label="Limpiar fecha"
                      @clear="formImportePendiente.FechaVencimiento = null"
                    />
                  </div>
                </div>

                <div>
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('procedings.Concepto')}}
                      <el-form-item prop="Concepto">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="formImportePendiente.Concepto"
                          maxlength='40'
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>

              </div>
            </el-form>
          </div>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-insert-importe">
              <base-button class="w-full" @click.stop.prevent="newImportePendienteToggleDialog()" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click.stop.prevent="() => {applyNewImportePendiente('importeRules')}"/>
            </div>
          </template>
        </BaseElDialog>
        <p-d-f-viewer-dialog
          :dialogOpen="showModalPDF"
          :idAdjunto="id"
          @toggleDialog="toggleDialogPdf" 
          isDiligencia
          />
    </template>
  </detail-layout>
</template>

<script>
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { i18n } from '@/i18n'
import BaseElDialog from '@/components/base/BaseElDialog.vue'
import PDFViewerDialog from '@/components/pdf/PDFViewerDialog.vue'

import { getClients } from '@/services/clients/getClients'

import { getProceding } from '@/services/procedings/getProceding'
import { newProceding } from '@/services/procedings/newProceding'
import { getDatosNEOProceding } from '@/services/procedings/getDatosNEOProceding' 
import { getCertificatesPresentationSimple } from '@/services/certificates/getCertificatesPresentationSimple' 

import { TIPOS_DILIGENCIAS } from '@/config/tipos-diligencias'
import { TIPOS_DILIGENCIAS_ESTADO } from '@/config/tipos-diligencias-estado'
import { sanitizePriceDecimal2Comma, sanitizePriceDecimal2Dot } from '@/utils/utils'

import BaseAccessibleTable from '@/components/tables/BaseAccessibleTable.vue'

import { descargardocumentodiligencia } from '@/services/procedings/descargardocumentodiligencia'
import { cambiarestadodiligencias } from '@/services/procedings/cambiarestadodiligencias'

export default {
  /* eslint-disable camelcase */
  name: 'proceding-detail',
  components: {
    DetailLayout,
    AccessibleElSelect,
    BaseElDialog,
    BaseAccessibleTable,
    PDFViewerDialog,
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      isMounted: false,
      isLoadingInitial: false,
      searchView: false,
      activeName: 'es',
      header: {
        title: 'DETALLE DE CONTESTACIÓN DE DILIGENCIA',
        icon: 'procedingmenu',
        breadcrumb: {},
        nav: [],
        url: 'procedings'
      },

      showModalPDF: false,
      disableNIFDeudor: false,
      showModalImportePendiente: false,
      tiposDiligencias: TIPOS_DILIGENCIAS,
      tiposDiligenciasEstado: TIPOS_DILIGENCIAS_ESTADO,
      formImportePendiente: {
        Importe: null,
        FechaVencimiento: null,
        Concepto: '',
      },
      form: this.getDefaultForm(),
      clientes: [],
      listCerts: [],
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      rulesProcedings: {
        NIFPagadora: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        NumDiligencia: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        NIFDeudor: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        Tipo: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' },
        ],
        Certificado: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' },
        ],
        RetribucionesPendientesNaturalezaSalarial: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ], 
        RetribucionesPendientesNaturalezaNoSalarial: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        ImporteEmbargoPrevio: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        FechaEmbargoPrevio: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
      },
      importeRules: {
        Importe: [
          { validator: this.isGenericValidationNotZero, trigger: 'blur' },
        ],
        FechaVencimiento: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
        // Opcional
        // Concepto: [
        //   { validator: this.isGenericValidation, trigger: 'blur' },
        // ],
      },
    }
  },
  computed: {
    isEmbargoPrevioVisible () {
      // En creación, se muestra si se indica que hay cantidades pendientes o relación comercial, o si el tipo es 2 (sueldos)
      if (this.isCreate) {
        return this.form.TieneCantidadesPendientesPagoORelacion || this.form.Tipo === 2
      } 
      // En edición, se muestra si hay cantidades pendientes o relación comercial y se han indicado datos del embargo (NIF o nombre del embargante), o si el tipo es 2 (sueldos)
      return (this.form.TieneCantidadesPendientesPagoORelacion || this.form.Tipo === 2) && (this.form.NIFEmbargante || this.form.NombreEmbargante)
    },
    ImportesPendientesMetadataColumns () {
      const columns = [
        { key: 'Concepto', label: this.$i18n.t('procedings.Concepto'), align: 'left' },
        { key: 'FechaVencimiento', label: this.$i18n.t('procedings.FechaVencimiento'), align: 'center' },
        { key: 'Importe', label: this.$i18n.t('procedings.Importe'), align: 'right' },
        { key: 'actions', label: '-', width: '80px', align: 'center' },
      ]
      if (!this.isCreate) columns.splice(-1)
      return columns
    },
    certificadosForAccessibleSelect () {
      return this.listCerts.map(item => ({
        id: item.key,
        name: item.Nombre,
        value: item.key
      }))
    },
    TiposForAccessibleSelect: function () {
      return this.tiposDiligencias.map(item => ({
        id: item.id,
        name: item.name
      }))
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return parseInt(this.$route.params.id)
    },
    idNEO: function () {
      return this.isCreate ? parseInt(this.$route.params.idNEO) : this.form.idNEO
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    clientesForAccessibleSelect () {
      return this.clientes.map(cliente => ({ 
        id: cliente.IdEmpresa, 
        value: cliente.IdEmpresa, 
        name: cliente.Nombre 
      }))
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
  },
  created: async function () {
    this.isLoadingInitial = true
    const breadcrumbs = []

    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas
    } 
    breadcrumbs.push({ path: 'procedings', name: this.$i18n.t('procedings.title') })

    if (!this.isCreate) {
      this.isLoadingInitial = true
      await this.downloadData(this.id)
      breadcrumbs.push({ path: '', name: this.form.NumDiligencia })
      this.$store.commit('app/setheaderBreadCrumb', this.form.NumDiligencia)
    } else {
      breadcrumbs.push({
        path: '',
        name: this.$i18n.t('procedings.new')
      })
    }
    this.header.breadcrumb = breadcrumbs

    if (this.isCreate) {
      await this.getDatosNEOHandler()
    } 
    this.getCertificatesHandler()

    this.isLoadingInitial = false
  },
  mounted () {
    if (this.isCreate) this.openCollapsibles()
    this.resetControlFormChanges()
  },
  methods: {
    isGenericValidationNotZero: function (rule, value, callback) {
      // NO Permitimos valores 0
      if (value === null || value === undefined || value === '' || value === 0 || value === '0') {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      } else {
        callback()
      }
    },
    actualizarEstadoHandler: async function (idEstadoFinal = null) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idDiligencias: [this.id],
          idEstado: idEstadoFinal,
        }
        const res = await cambiarestadodiligencias(payload)
        if (res.blnError) {
          this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
        } else {
          this.doFeedback('Acción tramitada correctamente', 'success')
          this.$router.push({ name: 'procedings' })
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleDialogPdf () {
      this.showModalPDF = !this.showModalPDF
    },
    downloadAdjunto: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const params = {
          idDiligencia: this.id
        }
        const response = await descargardocumentodiligencia(params)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          const fileName = 'respuesta-diligencia-' + this.id + '.pdf'
          this.downloadBlob(response, fileName)
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    openCollapsibles () {
      this.$refs.baseCollapsibleProcedingCreditos.toggle()
      // this.$refs.baseCollapsibleProcedingSueldos.toggle()
      this.$refs.baseCollapsibleProcedingEmbargoPrevio.toggle()
      this.$refs.baseCollapsibleProcedingInformacionAdicional.toggle()
      this.$refs.baseCollapsibleProcedingCert.toggle()
    },
    newImportePendienteToggleDialog () {
      this.showModalImportePendiente = !this.showModalImportePendiente
      if (!this.showModalImportePendiente) {
        this.formImportePendiente = {
          Importe: null,
          FechaVencimiento: null,
          Concepto: '',
        }
      }
    },
    deleteImportePendiente: async function (row) {
      try {
        this.$store.commit('setIsLoading', true)
        this.form.ImportesPendientes = this.form.ImportesPendientes
          .filter(x => x.idImporte !== row.idImporte)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyNewImportePendiente: async function (formName) {
      try {
        this.$store.commit('setIsLoading', true)
        this.$refs[formName].validate(async (valid) => {
          if (!valid) {
            this.doFeedback(this.$i18n.t('feedback.error.validation'))
            return
          }
          this.form.ImportesPendientes.push({
            idImporte: uuidv4(),
            Importe: sanitizePriceDecimal2Comma(this.formImportePendiente.Importe, true),
            FechaVencimiento: moment(this.formImportePendiente.FechaVencimiento).format('YYYY-MM-DD'),
            Concepto: this.formImportePendiente.Concepto || null,
          })
          this.newImportePendienteToggleDialog()
        })
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    getDatosNEOHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)

        const paramsAux = this.$route.params
        // Check params
        if (paramsAux.id && paramsAux.idNEO && paramsAux.NumDiligencia && paramsAux.NIFPagadora && paramsAux.TicketID) {
          this.form.NumDiligencia = paramsAux.NumDiligencia
          this.form.NIFPagadora = paramsAux.NIFPagadora
          if (paramsAux.NIFDeudor) {
            this.form.NIFDeudor = paramsAux.NIFDeudor
            this.disableNIFDeudor = true
          }
          this.form.TicketID = paramsAux.TicketID
        } else {
          // Get data NEO
          const dataNEO = await getDatosNEOProceding({ idNEO: this.idNEO })
          if (dataNEO.blnError) {
            this.doFeedback(dataNEO.msgError + ' [Código de error: ' + dataNEO.codError + ']')
          } else {
            this.form.NumDiligencia = dataNEO.Respuesta?.NumDiligencia
            this.form.NIFPagadora = dataNEO.Respuesta?.NIFPagadora
            this.form.NIFDeudor = dataNEO.Respuesta?.NIFDeudor 
            this.form.TicketID = dataNEO.Respuesta?.TicketID
          }
        }
      } catch (error) {
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    getCertificatesHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idNEO: this.idNEO
        }
        const certs = await getCertificatesPresentationSimple(params)
        if (certs.blnError) {
          this.doFeedback(certs.msgError + ' [Código de error: ' + certs.codError + ']')
        }
        this.listCerts = certs.respuesta.map((x, index) => { return { ...x, key: index } })
        const certDefecto = this.listCerts.filter(x => x.PorDefecto)
        if (certDefecto && certDefecto.length === 1) {
          this.form.Certificado = certDefecto[0].key
          this.resetControlFormChanges()
        }
      } catch (error) {
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    getDefaultForm: function () {
      return {
        id: 0,
        clienteId: null,
        TicketID: '',
        idNEO: '',
        NIFPagadora: '',
        NumDiligencia: '',
        NIFDeudor: '',
        Tipo: 1,
        TieneCantidadesPendientesPagoORelacion: false,
        TieneRelacionComercial: false,
        ImportesPendientes: [],
        MantieneRelacionLaboral: false,
        RetribucionesSalarialesSuperioresSMI: false,
        RetribucionesNoSalariales: false,
        TieneCantidadesPendientesPago: false,
        RetribucionesPendientesNaturalezaSalarial: '',
        RetribucionesPendientesNaturalezaNoSalarial: '',
        NIFEmbargante: '',
        NombreEmbargante: '',
        ImporteEmbargoPrevio: '',
        FechaEmbargoPrevio: '',
        DatosAdicionalesEmbargo: '',
        TelefonoContacto: '',
        Observaciones: '',
        Certificado: null,
        CertificadoCN: null,
        idEstado: null,
        Estado: '',
        CSV: '',
        Error: '',
      }
    },
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      if (this.isCreate) {
        this.newProcedingHandler(formName)
      }
    },
    newProcedingHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const certSelected = this.listCerts.filter(x => x.key === this.form.Certificado)[0]
          const params = {
            idCliente: this.form.clienteId,
            idNEO: this.idNEO,
            // TicketID: this.form.TicketID,
            NIFPagadora: this.form.NIFPagadora,
            NumDiligencia: this.form.NumDiligencia,
            NIFDeudor: this.form.NIFDeudor,
            idTipo: this.form.Tipo,
            DiligenciaCreditos: this.form.Tipo === 1 ? {
              TieneCantidadesPendientesPagoORelacion: this.form.TieneCantidadesPendientesPagoORelacion,
              TieneRelacionComercial: this.form.TieneRelacionComercial,
              ImportesPendientes: this.form.ImportesPendientes.map(x => ({ 
                ...x,
                FechaVencimiento: x.FechaVencimiento ? moment(x.FechaVencimiento).format('YYYY-MM-DD[T00:00:00]') : null,
                // FechaVencimiento: moment(x.FechaVencimiento, 'DD-MM-yyyy').toDate(),
                Importe: sanitizePriceDecimal2Dot(x.Importe), 
              }))
            } : null,
            DiligenciaSueldos: this.form.Tipo === 2 ? {
              MantieneRelacionLaboral: this.form.MantieneRelacionLaboral,
              RetribucionesSalarialesSuperioresSMI: this.form.RetribucionesSalarialesSuperioresSMI,
              RetribucionesNoSalariales: this.form.RetribucionesNoSalariales,
              TieneCantidadesPendientesPago: this.form.TieneCantidadesPendientesPago,
              RetribucionesPendientesNaturalezaSalarial: sanitizePriceDecimal2Dot(this.form.RetribucionesPendientesNaturalezaSalarial),
              RetribucionesPendientesNaturalezaNoSalarial: sanitizePriceDecimal2Dot(this.form.RetribucionesPendientesNaturalezaNoSalarial),
            } : null,
            EmbargoPrevio: this.form.NIFEmbargante || this.form.NombreEmbargante || this.form.ImporteEmbargoPrevio || this.form.FechaEmbargoPrevio || this.form.DatosAdicionalesEmbargo ? {
              NIFEmbargante: this.form.NIFEmbargante,
              NombreEmbargante: this.form.NombreEmbargante,
              ImporteEmbargoPrevio: sanitizePriceDecimal2Dot(this.form.ImporteEmbargoPrevio),
              // ImporteEmbargoPrevio: this.$i18n.n(this.form.ImporteEmbargoPrevio, 'currency'),
              FechaEmbargoPrevio: this.form.FechaEmbargoPrevio ? moment(this.form.FechaEmbargoPrevio).format('YYYY-MM-DD[T00:00:00]') : null,
              DatosAdicionalesEmbargo: this.form.DatosAdicionalesEmbargo,
            } : null,
            InformacionAdicional: this.form.TelefonoContacto || this.form.Observaciones ? {
              TelefonoContacto: this.form.TelefonoContacto,
              Observaciones: this.form.Observaciones,
            } : null,
            IdEmpresa: certSelected.IdEmpresa,
            SerialNumber: certSelected.SerialNumber,
            TipoCertificado: certSelected.TipoCertificado,
          }

          const response = await newProceding(params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Datos guardados correctamente', 'success')
            // this.resetForm()
            // this.form = this.getDefaultForm()
            this.$store.commit('app/setFormChanges', false)
            this.$router.push({ name: 'procedings' })
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    onImporteEmbargoPrevioInput (value) {
      this.form.ImporteEmbargoPrevio = sanitizePriceDecimal2Comma(value)
    },
    onImporteInput (value) {
      this.formImportePendiente.Importe = sanitizePriceDecimal2Comma(value)
    },
    onRetribucionesPendientesNaturalezaSalarialInput (value) {
      this.form.RetribucionesPendientesNaturalezaSalarial = sanitizePriceDecimal2Comma(value)
    },
    onRetribucionesPendientesNaturalezaNoSalarialInput (value) {
      this.form.RetribucionesPendientesNaturalezaNoSalarial = sanitizePriceDecimal2Comma(value)
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    goBack: function () {
      this.$router.push({ name: 'procedings' })
    },
    downloadData: async function (id) {
      let data = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idDiligencia: id
        }
        data = await getProceding(params)
        this.setProceding(data.Respuesta)
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return data
    },
    setProceding: function (data) {
      this.form.clienteId = data.idEmpresa
      this.form.TicketID = data.TicketID
      this.form.idNEO = data.idNEO
      this.form.NIFPagadora = data.NIFPagadora
      this.form.NumDiligencia = data.NumDiligencia
      this.form.NIFDeudor = data.NIFDeudor
      this.form.Tipo = data.idTipo

      this.form.TieneCantidadesPendientesPagoORelacion = data.DiligenciaCreditos?.TieneCantidadesPendientesPagoORelacion
      this.form.TieneRelacionComercial = data.DiligenciaCreditos?.TieneRelacionComercial
      this.form.ImportesPendientes = data.DiligenciaCreditos?.ImportesPendientes ? data.DiligenciaCreditos?.ImportesPendientes
        .map(x => ({ 
          ...x,
          // FechaVencimiento: moment(x.FechaVencimiento, 'DD-MM-yyyy').toDate(),
          FechaVencimiento: moment(x.FechaVencimiento).format('YYYY-MM-DD'),
          Importe: sanitizePriceDecimal2Comma(x.Importe, true), 
        })) : []

      this.form.MantieneRelacionLaboral = data.DiligenciaSueldos?.MantieneRelacionLaboral
      this.form.RetribucionesSalarialesSuperioresSMI = data.DiligenciaSueldos?.RetribucionesSalarialesSuperioresSMI
      this.form.RetribucionesNoSalariales = data.DiligenciaSueldos?.RetribucionesNoSalariales
      this.form.TieneCantidadesPendientesPago = data.DiligenciaSueldos?.TieneCantidadesPendientesPago
      this.form.RetribucionesPendientesNaturalezaSalarial = data.DiligenciaSueldos?.RetribucionesPendientesNaturalezaSalarial ? sanitizePriceDecimal2Comma(data.DiligenciaSueldos?.RetribucionesPendientesNaturalezaSalarial, true) : null
      this.form.RetribucionesPendientesNaturalezaNoSalarial = data.DiligenciaSueldos?.RetribucionesPendientesNaturalezaNoSalarial ? sanitizePriceDecimal2Comma(data.DiligenciaSueldos?.RetribucionesPendientesNaturalezaNoSalarial, true) : null

      this.form.NIFEmbargante = data.EmbargoPrevio?.NIFEmbargante
      this.form.NombreEmbargante = data.EmbargoPrevio?.NombreEmbargante
      this.form.ImporteEmbargoPrevio = data.EmbargoPrevio?.ImporteEmbargoPrevio ? sanitizePriceDecimal2Comma(data.EmbargoPrevio?.ImporteEmbargoPrevio, true) : null
      this.form.FechaEmbargoPrevio = data.EmbargoPrevio?.FechaEmbargoPrevio ? moment(data.EmbargoPrevio?.FechaEmbargoPrevio).format('YYYY-MM-DD') : null
      this.form.DatosAdicionalesEmbargo = data.EmbargoPrevio?.DatosAdicionalesEmbargo

      this.form.TelefonoContacto = data.InformacionAdicional?.TelefonoContacto
      this.form.Observaciones = data.InformacionAdicional?.Observaciones

      this.form.Certificado = {
        IdEmpresa: data.idEmpresa,
        SerialNumber: data.SerialNumber,
        TipoCertificado: data.TipoCertificado,
      }
      this.form.CertificadoCN = data.CommonName

      this.form.idEstado = data.idEstado
      this.form.Estado = data.idEstado !== null ? this.tiposDiligenciasEstado.filter(x => x.id === data.idEstado)[0]?.name : null
      this.form.CSV = data.CSV
      this.form.Error = data.Error
 
      setTimeout(() => {
        this.isLoadingInitial = false
      }, 100)
      this.resetControlFormChanges()
    },
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
